import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

export const DeleteModal = ({ type, onDelete, onClose }: {
  type: string,
  onDelete: () => void,
  onClose: () => void
}) => <Modal isOpen size='medium'>
  <ModalHeader title={`Delete event type '${type}'?`} onClose={onClose} />
  <ModalBody>There is no undo.  Once deleted, this event type will be removed from all events.</ModalBody>
  <ModalFooter>
    <ButtonControl
      title='Delete'
      variant='danger'
      onClick={onDelete} />
    <ButtonControl
      title='Cancel'
      onClick={onClose} />
  </ModalFooter>
</Modal>
